document.addEventListener('DOMContentLoaded', function () {
    var acc = document.querySelectorAll(".wp-block-icb-icb005-highlight-cta .accordion-toggle");
    var i;

    for (i = 0; i < acc.length; i++) {
        // Skip if already initialized
        if (acc[i].hasAttribute('data-accordion-initialized')) {
            continue;
        }
        
        acc[i].setAttribute('data-accordion-initialized', 'true');
        acc[i].addEventListener("click", function() {
            this.classList.toggle("active");
            var panel = this.nextElementSibling;
            if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
            } else {
                panel.style.maxHeight = panel.scrollHeight + "px";
            }
        });
    }
});